import React from "react";

const ContentSection = (props) => {
    return (
        <section className="content-section">
            {props.children}
        </section>
    );
};

export default ContentSection;